module Tapas.Bindings {
    export class Menu {
        public init(element: any, valueAccessor: () => any, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {
            if (!bindingContext)
                return;

            var ele = $(element);
            ele.click(function (e) {
                var _this = $(this);
				var target = $(e.target);

				if (target.hasClass('visible')) {
					_this.removeClass('visible');

					if (_this.hasClass("menu")) {
						_this.children().fadeOut(200)
					}
				}
				else if (target.hasClass('mobileReset')) {
					$('.visible').removeClass('visible').children().fadeOut(200);
					bindingContext.$data.menuOpen(true);
                } else if (target.hasClass('item')) {
                    $('.item.visible').removeClass('visible');
                    _this.addClass('visible');
                    bindingContext.$data.menuOpen(true);
                }
				else if (target.hasClass('hasDrop')) {
					$('.visible').removeClass('visible').children().hide();
					_this.addClass('visible');

					!bindingContext.$data.menuOpen() ? _this.children().fadeIn(200) : _this.children().show();

					bindingContext.$data.menuOpen(true);
				}
				
				if (target.hasClass('ecom')) {
					_this.children().addClass('active').not(':first').remove();
				}

				e.stopPropagation();
            });
        }
    }
    ko.bindingHandlers['menu'] = new Menu();
} 
